module.exports = __webpack_public_path__ + "img/climate-spiral.3524cfdc.gif";